import Swiper from "swiper";
import { Navigation, Pagination } from 'swiper/modules';

// Import sliders
import { sliderGalleryV1 } from "./gallery/v1/slider";
import { sliderGalleryLoghi } from "./gallery/loghi/slider";
import { sliderGalleryV2 } from "./gallery/v2/slider";
import { sliderGalleryV3 } from "./gallery/v3/slider";
import { sliderReviewV1 } from "./review/v1/slider";
import { sliderAppartamentiV1 } from "./appartamenti/v1/slider";
import { sliderPtV1 } from "./pt/v1/slider";
import { sliderPtV2 } from "./pt/v2/slider";
import { sliderJobsV1 } from "./jobs/v1/slider";

// Registra i moduli
Swiper.use([Navigation, Pagination]);

// Array di tutti gli slider
const sliders = [
    sliderGalleryV1,
    sliderGalleryLoghi,
    sliderGalleryV2,
    sliderGalleryV3,
    sliderReviewV1,
    sliderAppartamentiV1,
    sliderPtV1,
    sliderPtV2,
    sliderJobsV1
];

// Inizializza tutti gli slider
sliders.forEach(slider => {
    if (slider.elements.length) {
        slider.elements.forEach(element => {
            new Swiper(element, slider.details(element));
        });
    }
});


import { Fancybox } from "@fancyapps/ui";
